<!-- 个人信息 -->
<template>
  <basic-container>
    <div class="header">
      <div class="header-left">
        <el-avatar icon="el-icon-user-solid"></el-avatar>
        <div class="header-left-content">
          <span>{{userInfo.user_name}}( {{userInfo.account}} )</span>
          <span>{{userInfo.db_name}} - {{userInfo.company_name}}</span>
        </div>
      </div>
      <div class="header-right">
        <el-button v-if="disabled" size="small" type="success" @click="handleDisabled" icon="el-icon-edit">编辑</el-button>
        <el-button v-else size="small" type="primary" @click="handleSave" icon="el-icon-download">保存</el-button>
      </div>
    </div>
    <el-tabs v-model="activeIndex" type="border-card" @tab-click='tabClick' @tab-remove='tabRemove'>
      <el-tab-pane name="0" label="个人信息">
        <info :disabled="disabled" :user="userObj" ref="info" @success="success"></info>
      </el-tab-pane>
      <!-- <el-tab-pane name="1" label="修改密码">
        <psd :disabled="disabled" ref="modifyPsd" :rulesPsd="rules"></psd>
      </el-tab-pane> -->
      <el-tab-pane name="2" label="个性化设置">
        <user-set :disabled="disabled" :user="userObj" ref="userSet" @success="success"></user-set>
      </el-tab-pane>
    </el-tabs>
  </basic-container>
</template>
<script>
  import { mapGetters } from "vuex";
  import { getUserInfo } from "@/api/system/user"
  import { getDictionary } from "@/api/system/dict.js";
  import info from "./userinfo"
  import psd from "./modifyPsd"
  import userSet from "./userSet"
  export default {
    components: {
      info,
      psd,
      userSet
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    data() {
      return {
        activeIndex: "0",//激活
        disabled:true,
        userObj:{}, // 数据
        rules:[],// 校验
      }
    },
    watch:{
      "$route"(){
        this.activeIndex=this.$route.query.type||"0"; // 初始化状态
      }
    },
    created() {
      this.activeIndex=this.$route.query.type||"0"; // 初始化状态
    },
    mounted() {
    },
    activated() {
      this.obtainInformation();//获取人员信息
    },
    methods: {
      // 提交成功后的方法
      success(){
        this.disabled=true;
        //个人信息保存成功后获取信息
        if(this.activeIndex == '0'){ 
          this.obtainInformation()
        }
      },
      // 获取信息
      obtainInformation(){
        getUserInfo().then(res=>{
          console.log(res.data.data);
          this.userObj=res.data.data;
          getDictionary({ 'code': "SYS_USER_STATUS" }).then(res=>{
            this.$set(this.userObj,"statusText",res.data.data.find(i=>{return i.dictKey==this.userObj.status}).dictValue);
            this.$set(this.userObj,"statuscolor",res.data.data.find(i=>{return i.dictKey==this.userObj.status}).color);
          })
        },err=>{

        })
      },
      //tab标签点击时，缓存当前tab
      tabClick(tab) {
        this.$router.push({
          path:"/info/index",
          query:{
            runId:"",
            type:tab.name,
          }
        })
        this.disabled = true;
        // 切换清除校验、初始化form
        if (this.activeIndex == '0') {
          this.$refs.info.clearValidateorForm()
        } else if (this.activeIndex == '1') {
          this.$refs.modifyPsd.clearValidateorForm()
        }else if(this.activeIndex == '2'){
          this.$refs.userSet.clearValidateorForm()
        }
      },
      //编辑
      handleDisabled() {
        this.disabled = false
      },
      //保存
      handleSave() {
        if (this.activeIndex == '0') {
          console.log(this.$refs.info);
          this.$refs.info.handleSubmit()
        } else if (this.activeIndex == '1') {
          this.$refs.modifyPsd.handleSubmit()
        } else if (this.activeIndex == '2') {
          this.$refs.userSet.handleSubmit()
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    line-height: 60px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    background-color: #EBEEF5;


    /deep/.el-avatar {
      margin: 4px 10px 4px 10px;
      width: 52px;
      height: 52px;
      line-height: 52px;
    }

    /deep/.el-button--small {
      padding: 12px 20px;
      font-size: 15px;
    }
  }

  .header-left {
    display: flex;
    justify-content: flex-start
  }

  .header-left-content {
    display: inline-flex;
    flex-direction: column;

    span {
      line-height: 26px;
      font-size: 15px !important;
      font-weight: 600;
      color: #909399
    }

    span:first-child {
      padding-top: 4px;
    }

    span:last-child {
      padding-bottom: 4px;
    }
  }

  /deep/ .el-tabs__item {
    height: 48px;
    line-height: 48px;
    font-size: 15px;
  }

  /deep/.el-tabs--border-card>.el-tabs__header {
    background-color: #FFF;
    border-bottom: 1px solid #E4E7ED;
    margin: 0;
  }

  /deep/.el-tabs__item.is-active {
    border-right-color: #fff !important;
    border-left-color: #fff !important;
    border-bottom: 3px solid #2E5AE8 !important;
  }
  /deep/.el-tabs__content{
    padding: 6px 0px 0px 0px !important;
  }
  /deep/.el-tabs--border-card {
    background: #FFF;
    border: none !important;
    box-shadow: none !important;
  }
  /deep/.el-card__body{
    min-height: 500px;
    padding: 20px !important;
  }
/* 父、子组件 */
  /deep/.el-form-item__label,
  /deep/.el-input, /deep/.el-radio, /deep/.el-radio__label{
    font-size: 15px !important;
  }
</style>
